import SettingsOverlay from './settings-overlay';
import ChangePassword from './password/change-password';
import SmsReminder from './sms/sms-notifications';

export default {
    SettingsOverlay,
    ChangePassword,
    SmsReminder,
};
